<template>
  <div class="u-layer" v-show="visible">
    <transition name="tips">
      <div class="u-layer_box" v-if="visible">
        <div class="u-layer_built">
          <div class="close" @click="CloseClick"></div>
          <div class="u-layer_main">
            <slot name="icobg"></slot>
            <slot name="title"></slot>
            <slot name="tips"></slot>
            <slot name="con"></slot>
            <div class="btnbox clearfix">
              <u-button type="primary" @click.native="CloseClick">{{ cancel ? cancel : '取消' }}</u-button>
              <slot name="sureBtn"></slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ULayer',
  data() {
    return {};
  },
  props: {
    visible: Boolean,
    cancel: String,
  },
  mounted() {},
  methods: {
    //关闭弹层
    CloseClick() {
      this.$emit('change', { visible: false });
    },
  },
};
</script>
<style lang="scss" scoped>
//弹框
.u-layer {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba($color: #000000, $alpha: 0.5);
  z-index: 3000;
  .u-layer_box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .u-layer_built {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
  .u-layer_main {
    width: 6.24rem;
    min-height: 3.8rem;
    max-height: 10rem;
    background: #fff;
    overflow: hidden;
    overflow-y: auto;
    border-radius: 0.4rem;
    padding: 0.6rem 0;
    .btn {
      // background: url(../img/detail/btnbg.png) no-repeat 0 0;
      // background-size: 100% 100%;
      // margin: 0 auto;
      // color: #844e13;
      // font-size: .36rem; font-weight: bold;
    }
    .layer-btn-bottom {
      // background: url(../img/detail/btn_log.png) no-repeat 0 0;
      // background-size: 100% 100%;
      // @include elementSize(3rem,.8rem);
      // line-height: .8rem;
      // position: absolute; bottom: -1.44rem; left: 50%;
      // margin-left: -1.5rem;
      // color: #844e13;
      // font-size: .36rem; font-weight: bold;
    }
  }
}
</style>
<style lang="scss">
.u-layer {
  .vtitle {
    font-size: 0.36rem;
    line-height: 0.44rem;
    padding: 0.24rem 0.5rem 0;
  }
  .vtips {
    font-size: 0.28rem;
    color: #666666;
    line-height: 0.36rem;
    padding: 0.4rem 0.6rem;
  }
}
</style>
